import { useState, useCallback } from 'react';

interface IPredictConfig {
  bigCarConfig: {
    predictLimit: number;
    timeStep: number;
  };
  smallCarConfig: {
    predictLimit: number;
    timeStep: number;
  };
}

const defaultConfig = {
  bigCarConfig: {
    predictLimit: 3,
    timeStep: 30,
  },
  smallCarConfig: {
    predictLimit: 3,
    timeStep: 10,
  },
};

export default function PredictConfig() {
  const [config, setConfig] = useState<IPredictConfig>(defaultConfig);
  // eslint-disable-next-line
  const setPredictConfig = useCallback(setConfig, []);
  const resetPredictConfig = useCallback(() => {
    setPredictConfig(defaultConfig);
  }, [setPredictConfig]);

  return {
    config,
    setPredictConfig,
    resetPredictConfig,
  };
}
